import HealthInfoQuestion from 'components/Dashboard/components/SurveyPage/components/V2/HealthInfoQuestion/HealthInfoQuestion';
import { QuestionPageProps } from 'components/Dashboard/components/SurveyPage/types';

import React from 'react';

const DISEASES = [
  'Nephrotic syndrome',
  'Nephritic syndrome',
  'Glomerulonephritis',
  'Kidney stones',
  'Other',
];

const KidneyDiseaseQuestion: React.FC<QuestionPageProps> = ({ onNext, onPrev, onSubmit }) => {
  return <HealthInfoQuestion onPrev={onPrev} onNext={onNext} onSubmit={onSubmit} field="kidneyDisease" diseases={DISEASES} />;
};

export default KidneyDiseaseQuestion;
